<template>
    <div class="go-to-top-component">
        <div class="go-to-top">
            <div class="arrow-up" data-scroll>
                <div class="top btn"><i class="fas fa-arrow-up fa-2x"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import SweetScroll from 'sweet-scroll'

export default {
    name: 'GotoTop',
    mounted() {
        new SweetScroll()
    }
}
</script>

<style lang="sass" scoped>
.go-to-top
    position: relative

    .arrow-up
        background-color: $dutche-primary-yellow
        position: absolute
        right: 0
        margin-right: 2rem
        margin-top: -2rem
        padding: 7px 2px
        border-radius: 10px

    .arrow-up i
        color: $dutche-primary-violet
        cursor: pointer

    .arrow-up i:hover
        color: $dutche-primary-orange


@media(min-width: 992px)
    .go-to-top .arrow-up
        margin-right: 5rem
        margin-top: -2.5rem
        padding: 0.9rem

@media (max-width: 768px)
    .arrow-up
        right: calc(20vw - (100vw - 55%)) !important
        bottom: 0vh !important
        margin-right: 3rem !important
</style>
